import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';

@Component({
  selector: 'app-about-institute',
  templateUrl: './about-institute.component.html',
  styleUrls: ['./about-institute.component.scss']
})
export class AboutInstituteComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
